
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[alias]",
      function () {
        return require("private-next-pages/blog/[alias]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[alias]"])
      });
    }
  